<template>
  <div class="material-wrap">
    <div class="header-wrap">
      <el-select
        class="select-item"
        v-model="filterData.productIds"
        filterable
        style="width: 240px"
      >
        <el-option label="全部产品" :value="-1"> </el-option>
        <el-option
          v-for="item of appList"
          :key="item.app_cloud_id"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.app_cloud_id"
        >
        </el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.tag" filterable>
        <el-option label="全部标签" :value="-1"> </el-option>
        <el-option v-for="item of tagList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.demander" filterable>
        <el-option label="全部制作人" :value="-1"> </el-option>
        <el-option v-for="item of userList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.creativeSource" placeholder="是否原创">
        <el-option label="全部原创类型" :value="-1"> </el-option>
        <el-option label="是原创" value="是"> </el-option>
        <el-option label="非原创" value="否"> </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button class="submit-btn" style="margin-left: auto" @click="resetClick">重置</el-button>
      <el-button class="submit-btn" type="primary" @click="searchTable(true)">查询</el-button>
    </div>
    <div class="table-wrap">
      <div class="table-header">
        <el-radio-group v-model="materialType" size="small" @change="searchTable(true)">
          <el-radio-button class="radio-item" :label="2">视频</el-radio-button>
          <el-radio-button class="radio-item" :label="1">图片</el-radio-button>
        </el-radio-group>
        <el-input
          placeholder="请输入素材名称"
          suffix-icon="el-icon-search"
          style="width: 160px; margin-left: auto; margin-right: 16px"
          v-model="filterData.search"
          @change="searchTable(true)"
        >
        </el-input>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          :platType="2"
          @changeColumn="generateCols"
          :type="5"
        ></select-field>
      </div>
      <div class="content-table-wrap">
        <el-table :data="tableData" v-loading="loading" :max-height="tableMaxHeight">
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            min-width="120"
            :fixed="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[item.value] || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <!-- 状态 -->
              <span v-if="item.value === 'duration'">{{ scope.row[item.value] }}秒</span>
              <span v-else>{{ scope.row[item.value] || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTag, getDesigner, materialReport_gdt } from "@/api/report.js";
import { getCommonProductList } from "@/api/api.js";
import SelectField from "@/components/selectField.vue";
import moment from "moment";
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
export default {
  name: "materialReport_gdt",
  components: {
    SelectField,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      appList: [],
      tagList: [],
      userList: [],
      materialType: 1,
      filterData: {
        productIds: -1,
        tag: -1,
        demander: -1,
        creativeSource: -1,
        time: [
          moment().subtract(7, "days").format("YYYY-MM-DD"),
          moment().subtract(1, "days").format("YYYY-MM-DD"),
        ],
        search: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      loading: false,
      tableCols: [],
      tableData: [],
      fieldOptions: [
        {
          title: "属性数据",
          list: [
            { label: "标签", value: "tag" },
            { label: "制作人", value: "demanderName" },
            { label: "是否原创", value: "creativeSource" },
            { label: "类型", value: "direction" },
            { label: "尺寸", value: "resolution" },
            { label: "时长", value: "duration" },
            { label: "关联创意数", value: "creativeCount" },
          ],
        },
        {
          title: "推广数据",
          list: [
            { label: "花费(元)", value: "cost" },
            { label: "展示数", value: "showCnt" },
            { label: "点击数", value: "clickCnt" },
            { label: "目标转化数", value: "convertCnt" },
            { label: "千次展示成本(元)", value: "thousandDisplayPrice" },
            { label: "点击率", value: "ctr" },
            { label: "目标转化率", value: "convertCntRate" },
            { label: "点击成本(元)", value: "cpc" },
            { label: "目标转化成本(元)", value: "convertCntCost" },
          ],
        },
      ],
      staticOptions: [
        { label: "素材名称", value: "name" },
        { label: "素材ID", value: "materialId" },
      ],
      tableMaxHeight: window.innerHeight - 340,
    };
  },
  mounted() {
    this.initSelectOptions();
    this.searchTable(true);
  },
  methods: {
    initSelectOptions() {
      //产品
      getCommonProductList({ platType: 2 }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      //标签
      getTag().then((res) => {
        if (res.code === "0000") {
          this.tagList = res.tags;
        }
      });
      //制作人，需求发起人
      getDesigner().then((res) => {
        if (res.code === "0000") {
          this.userList = res.tags;
        }
      });
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
        materialType: this.materialType,
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData);
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    searchTable(resetPage) {
      this.loading = true;
      if (resetPage) {
        this.pageData.page = 1;
      }
      let parmas = this.formatData();
      materialReport_gdt(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableData = res.data.list.map((item) => {
            item.cost = item.cost.toFixed(2);
            item.ctr = (item.ctr * 100).toFixed(2) + "%";
            item.convertCntRate = (item.convertCntRate * 100).toFixed(2) + "%";
            return item;
          });
          this.pageData.total = res.data.total;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "tag",
          "demanderName",
          "creativeSource",
          "derection",
          "resolution",
          "duration",
          "creativeCount",
          "cost",
          "showCnt",
          "clickCnt",
          "convertCnt",
          "thousandDisplayPrice",
          "ctr",
          "convertCntRate",
          "cpc",
          "convertCntCost",
        ];
      }
      let allFieldsMap = this.fieldOptions[0].list.concat(this.fieldOptions[1].list); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    resetClick() {
      this.filterData = {
        productIds: -1,
        tag: -1,
        demander: -1,
        creativeSource: -1,
        time: [
          moment().subtract(7, "days").format("YYYY-MM-DD"),
          moment().subtract(1, "days").format("YYYY-MM-DD"),
        ],
        search: "",
      };
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchTable();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchTable();
    },
  },
};
</script>

<style lang="less" scoped>
.material-wrap {
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  .header-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 24px 0px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    .select-item {
      width: 180px;
      margin-right: 24px;
      margin-bottom: 16px;
    }
    .data-range {
      position: relative;
      margin-bottom: 16px;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .submit-btn {
      margin-bottom: 16px;
      padding: 0 20px;
    }
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    margin-top: 16px;
    .table-header {
      display: flex;
      margin-bottom: 16px;
      .radio-item {
        /deep/ .el-radio-button__inner {
          width: 88px;
          height: 32px;
          line-height: 32px;
          padding: 0px;
          font-size: 14px;
        }
      }
    }
    .content-table-wrap {
      width: calc(100vw - 265px);
    }
  }
}
</style>
